import React, { useEffect, useMemo, useState } from "react";
import Layout from "../../Shared/Layout";
import {
    makeStyles,
} from "@material-ui/core";
import styled from "styled-components";
import { Inertia } from "@inertiajs/inertia";
import MuiButton from "@material-ui/core/Button";
import { Field, Form as FinalForm } from "react-final-form";
import { getCookieValue } from "../../utils/getCookieValue";
import { Trans } from "../../utils/i18n";
import QueueDetailDropzone from "../../Shared/QueueDetailDropzone";
import { Alert } from "@material-ui/lab";
import Wrapper from "./Wrapper";

const ResponseWrapper = styled.div`
    width: 100%;
    margin-top: 30px;
`;

export default function Files({
    client,
    order,
    statuses,
    services,
    partners,
    coverages,
    settlements,
    materialOperations,
    files,
    userCanUpdate,
    orderattributes,
    orderhistories,
    extendedMode,
    permissions,
    returnUrl,
}) {
    const [formState, setFormState] = useState(undefined);
    const [response, setResponse] = useState(undefined);

    const onSubmit = async (data) => {
        setFormState("loading");
        await fetch(route("queue.store"), {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-XSRF-TOKEN": getCookieValue("XSRF-TOKEN"),
                "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify({
                ...data,
                returnUrl,
            }),
        })
            .then((res) => res.json())
            .then((response) => {
                if (response.success) {
                    setFormState("success");
                    setResponse("");
                    Inertia.visit(
                        returnUrl ||
                            route("queue.index", {
                                requesttype: order.requesttype_key,
                            })
                    );
                    return;
                }
                setResponse(response);
                setFormState("error");
            })
            .catch(() => {
                setFormState("error");
            });
    };

    return (
        <Wrapper>
            <FinalForm initialValues={order} onSubmit={onSubmit}>
                {({
                    handleSubmit,
                    submitting,
                    values,
                    form,
                    errors,
                    touched,
                }) => {
                    const currentStatus = statuses.find(
                        (item) => item.id == values.status_id
                    );

                    return (
                        <form onSubmit={handleSubmit}>
                            {extendedMode && (
                                <div>
                                    <h3>
                                        <Trans i18nKey="queueDetail.files">
                                            Files
                                        </Trans>
                                    </h3>
                                    <QueueDetailDropzone
                                        enableType
                                    />
                                </div>
                            )}

                            <div className={'flex justify-end gap-3 mt-10'}>
                                {permissions.includes(
                                    "queue_shipping_label"
                                ) && (
                                    <MuiButton
                                        variant="contained"
                                        color={"primary"}
                                        disabled={
                                            submitting ||
                                            currentStatus.key === "created" ||
                                            currentStatus.key === "closed" ||
                                            currentStatus.key === "canceled"
                                        }
                                        href={route("queue.shippinglabel", {
                                            ordernumber: order.number,
                                        })}
                                        target="_blank"
                                    >
                                        <Trans i18nKey="queueDetail.shippingLabelButton">
                                            CREATE SHIPPING LABEL
                                        </Trans>
                                    </MuiButton>
                                )}
                                {extendedMode && (
                                    <MuiButton
                                        variant="contained"
                                        disabled={submitting}
                                        onClick={() =>
                                            Inertia.visit(
                                                route("queue.index", {
                                                    requesttype:
                                                        order.requesttype_key,
                                                })
                                            )
                                        }
                                    >
                                        <Trans i18nKey="queueDetail.cancel">
                                            Cancel
                                        </Trans>
                                    </MuiButton>
                                )}
                                {/* <MuiButton
                                    variant="contained"
                                    color={"secondary"}
                                    disabled={
                                        submitting ||
                                        !order.permissions.file.create
                                    }
                                    type={"submit"}
                                    onClick={() => {
                                        form.change("saveAndCloseJob", false);
                                    }}
                                >
                                    <Trans i18nKey="queueDetail.save">
                                        Save
                                    </Trans>
                                </MuiButton> */}
                                {extendedMode == false && (
                                    <MuiButton
                                        variant="contained"
                                        color={"secondary"}
                                        disabled={
                                            submitting ||
                                            !order.permissions.file.create ||
                                            currentStatus.key === "closed"
                                        }
                                        type={"submit"}
                                        onClick={() => {
                                            form.change(
                                                "saveAndCloseJob",
                                                true
                                            );
                                        }}
                                    >
                                        <Trans i18nKey="queueDetail.saveAndClose">
                                            Save & close job
                                        </Trans>
                                    </MuiButton>
                                )}
                                <br />
                            </div>
                            <ResponseWrapper>
                                {response?.message && (
                                    <Alert severity="warning">
                                        {response?.message}
                                    </Alert>
                                )}
                            </ResponseWrapper>
                        </form>
                    );
                }}
            </FinalForm>
        </Wrapper>
    );
}

Files.layout = (page) => <Layout children={page} />;
